import { render, staticRenderFns } from "./CallList.vue?vue&type=template&id=b809bef2&scoped=true&"
import script from "./CallList.vue?vue&type=script&lang=js&"
export * from "./CallList.vue?vue&type=script&lang=js&"
import style0 from "./CallList.vue?vue&type=style&index=0&id=b809bef2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b809bef2",
  null
  
)

export default component.exports